import React from 'react'

import OldSignup from './old-signup'
import NewSignup from './new-signup'
import { IConnect } from './types'

/**
 * Hard switch between the two sign-up implementations. Build-time flag, so an unset or false
 * value renders today's page unchanged. That is the kill switch.
 */
const Signup = (props: IConnect): React.ReactElement => {
  const shouldUseNewFlow = process.env.REACT_APP_USE_NEW_SIGNIN_SIGNUP === 'true'
  if (shouldUseNewFlow) {
    return <NewSignup location={props.location} />
  }

  return <OldSignup {...props} />
}

export default Signup
